import React, {
  useLayoutEffect,
  useEffect,
  useState,
  useContext,
  useMemo,
} from 'react'

import LoadingContext from '../../context/Loading/Loading'
import { useModals } from '../PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider'

import { getOrder } from '../../utilities/api'
import {
  fullHeightContainer,
  removeFullHeightContainer,
  userDevice,
} from '../../utilities/helpers'

import { PageLoadingContainer } from '../PageLoadingContainer'
import { BackButton } from '../BackButton'
import { Event } from '../PurchaseFlow/components/Event'
import { MyTickets } from '../MyTickets'
import { MyTicketsSlider } from './MyTicketsSlider'
import { ActionBtns } from '../ActionBtns'
import { OrderFoodButton } from '../OrderFoodButton'
import { TicketModal } from '../TicketModal'

export default function EventDetailsWrapper({ orderId, eventId }) {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)

  const { openModal } = useModals()

  const [order, setOrder] = useState()

  const [show, setShow] = useState(false)

  const [ticketAction, setTicketAction] = useState('')

  const [ticketStatus, setTicketStatus] = useState('')

  const [ticket, setTicket] = useState()

  const [deviceType, setDeviceType] = useState('')

  useLayoutEffect(() => {
    const el = document.querySelector('#main-container')

    fullHeightContainer(el)

    return () => {
      removeFullHeightContainer(el)
    }
  }, [])

  useEffect(() => {
    showLoading()
    getMyOrders()
    setDeviceType(userDevice)
  }, [orderId])

  const getMyOrders = () => {
    getOrder(orderId)
      .then((res) => {
        let order
        const eventUUID = eventId || res?.data?.event?.uuid

        order = {
          ...res?.data,
          tickets: res?.data?.tickets.filter(
            (ticket) => (ticket.eventUUID || ticket.eventId) === eventUUID
          ),
        }

        console.log('eventUUID: ', eventUUID)
        console.log('order: ', order)
        setOrder(order)
        hideLoading()
      })
      .catch((err) => {
        console.error(err)
        hideLoading()
      })
  }

  // create function that is a promise so button spinner works
  const getOrders = async () => {
    return new Promise((resolve, reject) => {
      getMyOrders()
      resolve()
    }).catch((err) => {
      console.error(err)
      reject()
    })
  }

  const handleShow = () => setShow(true)

  const handleClick = (action, ticket) => {
    handleShow()
    setTicketAction(action)
    setTicket(ticket)
  }

  const event = useMemo(() => {
    if (eventId && order?.package?.events) {
      const fromPackage = order.package.events.find((e) => e?.uuid === eventId)
      if (fromPackage) return fromPackage
    }
    if (order?.event?.uuid) return order.event
    return (
      order?.package?.events?.find((e) => e?.uuid === eventId) || order?.event
    )
  }, [order, eventId])

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <section className="spacer-xs full-height-wrapper background-gradient">
          <div className="section-heading-sm">
            <h1>
              {deviceType && deviceType === 'Mobile'
                ? 'Tickets'
                : 'Event details'}
            </h1>
            <div className="tablet-desktop-only">
              <BackButton />
            </div>
          </div>
          <div className="mb-3">
            <OrderFoodButton order={order} event={event} />
          </div>
          {deviceType && deviceType === 'Mobile' && (
            <>
              <MyTicketsSlider
                order={order}
                event={event}
                handleClick={handleClick}
              />
              <ActionBtns
                eventObj={event}
                handleClick={handleClick}
                ticketStatus={ticketStatus}
                order={order}
              />
            </>
          )}
          {deviceType && deviceType === 'Desktop' && (
            <>
              <Event event={event} openModal={openModal} />
              <MyTickets
                order={order}
                eventObj={event}
                handleClick={handleClick}
                ticketStatus={ticketStatus}
              />
            </>
          )}

          <TicketModal
            ticketAction={ticketAction}
            setTicketStatus={setTicketStatus}
            show={show}
            setShow={setShow}
            ticket={ticket}
            event={event}
            order={order}
            getMyOrders={getOrders}
          />
        </section>
      )}
    </>
  )
}
